export default __webpack_public_path__ + "static/media/Google_play.715b888b.svg";